export default __webpack_public_path__ + "static/media/fontello.248bb421.woff2";